import { Card, CardContent } from "@rumbledirect/ui";
import { Suspense } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/common/button";
import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { ButtonGroup } from "@rumble-it/common-components/components";
import { Loading } from "@/components/common/loading";
import { UserPermissionsTable } from "@/pages/admin/users/permissions/components/user-permissions-table";

export default function UserPermissionsPage() {
  return (
    <>
      <Topbar
        title="Permissions"
        icon={{ style: "far", name: "cloud-check" }}
      />

      <Content>
        <ButtonGroup className="flex">
          <Link to="/users/permissions/create" className="ml-auto">
            <Button variant="grey" faIconLeft={{ style: "far", name: "plus" }}>
              Nieuwe permission
            </Button>
          </Link>
        </ButtonGroup>

        <Card>
          <Suspense
            fallback={
              <CardContent>
                <Loading />
              </CardContent>
            }
          >
            <UserPermissionsTable />
          </Suspense>
        </Card>
      </Content>
    </>
  );
}
